import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { makeStyles } from "@material-ui/core/styles";
import {
  TextField,
  InputAdornment,
  IconButton,
  Typography,
  Grid,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import SaveIcon from "@material-ui/icons/Save";
import MenuItem from "@material-ui/core/MenuItem";
import { calcularEdad } from "../../services/utils";

const useStyles = makeStyles((theme) => ({
  text: {
    position: "relative",
    paddingRight: 40,
  },
  input: {
    paddingRight: 45,
    marginTop: 5,
    marginBottom: 5,
    color: theme.palette.primary.main,
  },
  inputLabel: {
    color: theme.palette.primary.main,
    transform: "translate(0px, 0px) scale(1)",
  },
}));

export default function FieldDate(props) {
  const { fieldObject, register, errors } = props;
  const {
    fieldName,
    label,
    errorMessage,
    defaultValue,
    required,
    textSize,
    regex,
    min,
    max,
    optionsArray,
    mostrarEdadEvento,
    fechaEvento,
    edadActualEvento,
  } = fieldObject;
  const classes = useStyles();
  const [editMode, setEditMode] = useState(true);
  const [currentValue, setCurrentValue] = useState(defaultValue);

  function handleChange(event) {
    setCurrentValue(event.target.value);
  }

  // calcularEdad espera una fecha completa "YYYY-MM-DD" (igual que
  // ParticipanStandarData.jsx) — un currentValue a medio escribir (menos de
  // 10 chars) daría NaN, así que solo se muestra con el valor completo.
  const fechaCompleta = Boolean(
    mostrarEdadEvento && fechaEvento && currentValue && currentValue.length === 10
  );
  // Un año truncado (ej. "99" en vez de "1999") sigue siendo una fecha
  // "completa" de 10 caracteres ("0099-10-05") y calcularEdad la acepta sin
  // quejarse — el regex (mismo que bloquea el envío) es la única forma de
  // detectar que el año no es real antes de mostrar un número de edad falso.
  const fechaValida = fechaCompleta && (!regex || new RegExp(regex).test(currentValue));

  const mostrarEdad = fechaCompleta;

  return (
    <>
      <TextField
        margin="none"
        fullWidth
        label={label}
        disabled={!editMode}
        onChange={handleChange}
        helperText={errors[fieldName] ? errorMessage : null}
        error={Boolean(errors[fieldName])}
        defaultValue={defaultValue}
        inputRef={register({ required: required, pattern: new RegExp(regex) })}
        name={fieldName}
        type="date"
        InputLabelProps={{
          className: classes.inputLabel,
        }}
        InputProps={{
          className: classes.input,
          inputProps: {
            max: max,
            min: min,
          },
        }}
      />
      {mostrarEdad && fechaValida && (
       <Typography variant="h6" color="textSecondary">
          <b>{calcularEdad(currentValue, fechaEvento, edadActualEvento)}</b> años
          {edadActualEvento
            ? " (Edad a la fecha del evento)"
            : " (Edad al 31 de diciembre del año del evento)"}
        </Typography>
      )}
      {mostrarEdad && !fechaValida && (
        <Typography variant="h6" color="error">
          Edad no calculada, revisa la fecha de nacimiento
        </Typography>
      )}
    </>
  );
}
